import React from "react";
import { Helmet } from 'react-helmet-async';
import '../../../assets/styles/Interaction.css'
import interactionHero from "../../../assets/images/Interaction design.png";
import interactionFlow from "../../../assets/images/Interaction design.png";

const InteractionDesignPage = () => {
  return (
    <>
      <Helmet>
        {/* <!-- Primary Meta Tags for SEO --> */}
        <title> Interaction Design – BuddyTech Solutions </title>
        <meta name="description" content="Craft intuitive and engaging micro-interactions and animations for smoother UX." />
        <meta name="keywords" content="interaction design, micro-interactions" />

        {/* <!-- Open Graph / Facebook Meta Tags --> */}
        <meta property="og:title" content="Interaction Design – BuddyTech Solutions" />
        <meta property="og:description" content="Craft intuitive and engaging micro-interactions and animations for smoother UX." />
        <meta property="og:keywords" content="interaction design, micro-interactions" />
        <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
        <meta property="og:url" content="https://buddytechsolutions.in/services/uiux/interaction" />
        <meta property="og:type" content="website" />

        {/* <!-- Optional: Facebook App ID --> */}
        {/* <!-- <meta property="fb:app_id" content="your_facebook_app_id" /> --> */}

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Interaction Design – BuddyTech Solutions" />
        <meta name="twitter:description" content="Craft intuitive and engaging micro-interactions and animations for smoother UX." />
        <meta name="twitter:keywords" content="interaction design, micro-interactions" />
        <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
      </Helmet>
      <div className="interaction-container">
        <header className="interaction-hero">
          <div className="interaction-hero-content">
            <h1>Interaction Design</h1>
            <p>
              We design intuitive digital experiences by crafting thoughtful interactions that feel natural, responsive, and human-centered.
            </p>
          </div>
          <img src={interactionHero} alt="Interaction Hero" className="interaction-hero-img" />
        </header>

        <section className="interaction-section">
          <div className="interaction-text">
            <h2>What We Focus On</h2>
            <p>
              Interaction design bridges the gap between design and development. We define how users engage with interfaces through animations, transitions, gestures, and feedback mechanisms.
            </p>
            <ul>
              <li>Microinteractions & Motion Design</li>
              <li>Navigation & Flow Logic</li>
              <li>Onboarding Sequences</li>
              <li>Touch, Hover & Click Interactions</li>
              <li>Feedback & Response Behavior</li>
            </ul>
          </div>
          <img src={interactionFlow} alt="Interaction Flows" className="interaction-img" />
        </section>

        <section className="interaction-tools">
          <h2>Tools We Use</h2>
          <div className="tools-grid">
            <span>Framer</span>
            <span>Figma Smart Animate</span>
            <span>Adobe After Effects</span>
            <span>Protopie</span>
            <span>Principle</span>
            <span>Lottie</span>
            <span>Motion.dev</span>
            <span>React Spring</span>
          </div>
        </section>
        <h2 className="permanent-marker-regular">specialist - 1</h2>
        <section className="contact-options">
          <div className="contact-card email">
            <h2>📧 Email</h2>
            <p>Send us an email for inquiries, support or collaboration opportunities.</p>
            <a href="mailto:sureshperiyasamy98@gmail.com" target="_blank" rel="noopener noreferrer">
              Send Email
            </a>
          </div>

          <div className="contact-card whatsapp">
            <h2>💬 WhatsApp</h2>
            <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
            <a href="https://wa.me/919361367843" target="_blank" rel="noopener noreferrer">
              Chat on WhatsApp
            </a>
          </div>

          <div className="contact-card phone">
            <h2>📞 Call Us</h2>
            <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
            <a href="tel:+919361367843">Call Us</a>
          </div>
        </section>
        <h2 className="permanent-marker-regular">specialist - 2</h2>
        <section className="contact-options">
          <div className="contact-card email">
            <h2>📧 Email</h2>
            <p>Send us an email for inquiries, support or collaboration opportunities.</p>
            <a href="mailto:jprakash0502@gmail.com" target="_blank" rel="noopener noreferrer">
              Send Email
            </a>
          </div>

          <div className="contact-card whatsapp">
            <h2>💬 WhatsApp</h2>
            <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
            <a href="https://wa.me/919994694028" target="_blank" rel="noopener noreferrer">
              Chat on WhatsApp
            </a>
          </div>

          <div className="contact-card phone">
            <h2>📞 Call Us</h2>
            <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
            <a href="tel:+919994694028">Call Us</a>
          </div>
        </section>
        <h2 className="permanent-marker-regular">specialist - 3</h2>
        <section className="contact-options">
          <div className="contact-card email">
            <h2>📧 Email</h2>
            <p>Send us an email for inquiries, support or collaboration opportunities.</p>
            <a href="mailto:swethadee1407@gmail.com" target="_blank" rel="noopener noreferrer">
              Send Email
            </a>
          </div>

          <div className="contact-card whatsapp">
            <h2>💬 WhatsApp</h2>
            <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
            <a href="https://wa.me/916379359918" target="_blank" rel="noopener noreferrer">
              Chat on WhatsApp
            </a>
          </div>

          <div className="contact-card phone">
            <h2>📞 Call Us</h2>
            <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
            <a href="tel:+916379359918">Call Us</a>
          </div>
        </section>
      </div>
    </>
  );
};

export default InteractionDesignPage;